export default (ms: number) =>
    new Promise<void>((r) => {
        setTimeout(r, ms);
    });
